<template>
    <wrapper>
        <div class="row" style="padding-top:30px;">
      <div class="col m10 offset-m1">
      

        <form method="post" @submit="checkForm" >
        <div class="card z-depth-3" >
          <div class="card-content">
            <div class="row">
              <div class="input-field col m12">
                <span class="black-text">Current Password</span>
                <br />
                <input type="password" v-model="old_pw" required />
              </div>
              <div class="input-field col m12">
                <span class="black-text">New Password</span>
                <br />
                <input type="password" v-model="new_pw" required/>
              </div>
               <div class="input-field col m12">
                <span class="black-text">Confirm Password</span>
                <br />
                <input type="password" v-model="confirm_pw" required/>
              </div>
            </div>
            <div class="card-actions" style="text-align:center;">
              
              <loading-btn 
                                    v-bind:button_type="'submit'"
                                    v-bind:text="'Change'"
                                    v-bind:loading="loading"
                                    v-bind:custom_class="'btn'"
                                ></loading-btn>
            </div>
          </div>
          
        </div>
        </form>
      </div>
    </div>
    </wrapper>
</template>
<script>
import { createFormData } from './../../misc/CreateFormData.js';
export default {
    data()
    {
        return {
            old_pw:"",
            new_pw:"",
            confirm_pw:"",
        }
    },
    methods: {
        checkForm(e)
        {
            e.preventDefault();
            if (this.old_pw && this.new_pw && this.confirm_pw)
            {
                if (this.new_pw==this.confirm_pw)
                {
                    this.$store.dispatch("passwordChange",createFormData({
                        "new_pw":this.new_pw,
                        "old_pw":this.old_pw,
                    }));
                }   
                else 
                {
                     this.$notify({
                      group: 'error',
                      title: 'Error',
                      type: 'error',
                      text: "Password and confirm password should be the same"
                    });
                }
            }
        }
    },
    computed: {
        loading()
        {
            return this.$store.getters.login_loading;
        }
    },
}
</script>
<style lang="scss">
    
</style>